import { DatePipe } from '@angular/common';
import { Component, inject, input, model, OnInit } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ICaregiverDocumentationCount } from '@pflegix/types';
import {
  AppIconEntity,
  AppIconService,
  IconWithTextComponent,
  PanelComponent,
  SkeletonLoadingComponent,
  ToastService,
} from '@pflegix/ui';
import { DocumentationApi } from '../api';

@Component({
  selector: 'pfx-documentation-active-caregiver-stats',
  imports: [RouterModule, PanelComponent, SkeletonLoadingComponent, IconWithTextComponent, DatePipe],
  templateUrl: './documentation-active-caregiver-stats.component.html',
})
export class DocumentationActiveCaregiverStatsComponent implements OnInit {
  public businessPartnerId = input.required<string>();

  private documentationApi = inject(DocumentationApi);

  private toastService = inject(ToastService);

  private appIconService = inject(AppIconService);

  public isLoading = model(true);

  protected caregiverDocumentationCountData = model<ICaregiverDocumentationCount[] | null>(null);

  protected icons = {
    signature: this.appIconService.getAppIcon(AppIconEntity.DOCUMENTATION).icon,
  };

  public ngOnInit(): void {
    this.getCaregiversOfDependentWithDocumentationCount();
  }

  public async getCaregiversOfDependentWithDocumentationCount(): Promise<void> {
    this.isLoading.set(true);
    try {
      const caregivers = await this.documentationApi.getCaregiversOfDependentWithDocumentationCount(
        this.businessPartnerId()
      );

      this.caregiverDocumentationCountData.set(caregivers);
    } catch (error) {
      console.error(error);
      this.toastService.addErrorToast('Fehler beim Laden der Bewertungsstatistiken');
    } finally {
      this.isLoading.set(false);
    }
  }
}
